import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const RoleRoute = ({ children, allowedTypes }) => {
  const token = localStorage.getItem("token");
  const perfilAtivo = useSelector((state) => state.access.perfilAtivo);

  // Sem token → login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Se perfil ainda não carregou → não redireciona
  if (!perfilAtivo) {
    return children;
  }

  const tipo = perfilAtivo?.tipo;

  //  Tipo não autorizado
  if (allowedTypes && !allowedTypes.includes(tipo)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

RoleRoute.propTypes = {
  children: PropTypes.node.isRequired,
  allowedTypes: PropTypes.array,
};

export default RoleRoute;
